import React from 'react';
import Marquee from './Marquee';
import { Link } from 'react-router-dom';
import { Panel, Label, link } from './styles';
import { percentFormat } from '../../Utils/NumberFormatting';

export default (props) => (
	<Panel>
		<Label>Průběh sčítání:</Label>
		<Marquee>
			{props.districts.map(district => (
				district.meta[props.roundIndex] && <Link className={link} key={district.id} to={`/obvod/${district.id}`}>
					{district.name} ({percentFormat(district.meta[props.roundIndex].count, 0)})
				</Link>
			))}
		</Marquee>
	</Panel>
)
